import React from "react";

export const GoalCloseIcon = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M0.292893 1.70711C-0.0976312 1.31658 -0.097631 0.683417 0.292893 0.292893C0.683418 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L8.77817 7.36396C9.1687 7.75449 9.1687 8.38765 8.77817 8.77817C8.38765 9.1687 7.75449 9.1687 7.36396 8.77817L0.292893 1.70711Z"
      fill="white"
    />
    <path
      d="M1.7072 8.77824C1.31668 9.16877 0.683511 9.16877 0.292986 8.77824C-0.097538 8.38772 -0.097538 7.75456 0.292986 7.36403L7.36405 0.292963C7.75458 -0.0975615 8.38774 -0.0975614 8.77827 0.292963C9.16879 0.683487 9.16879 1.31665 8.77827 1.70718L1.7072 8.77824Z"
      fill="white"
    />
  </svg>
);

interface IconProps {
  color?: string;
}

export const GoalClockIcon = ({ color = "currentColor" }: IconProps) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g clipPath="url(#goalClockClip)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 13.125C10.3827 13.125 13.125 10.3827 13.125 7C13.125 3.61726 10.3827 0.875 7 0.875C3.61726 0.875 0.875 3.61726 0.875 7C0.875 10.3827 3.61726 13.125 7 13.125ZM7.65625 3.9375C7.65625 3.57506 7.36244 3.28125 7 3.28125C6.63756 3.28125 6.34375 3.57506 6.34375 3.9375V7C6.34375 7.20656 6.441 7.40106 6.60625 7.525L8.35625 8.8375C8.6462 9.05496 9.05754 8.9962 9.275 8.70625C9.49246 8.4163 9.4337 8.00496 9.14375 7.7875L7.65625 6.67187V3.9375Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 13.125C10.3827 13.125 13.125 10.3827 13.125 7C13.125 3.61726 10.3827 0.875 7 0.875C3.61726 0.875 0.875 3.61726 0.875 7C0.875 10.3827 3.61726 13.125 7 13.125ZM7.65625 3.9375C7.65625 3.57506 7.36244 3.28125 7 3.28125C6.63756 3.28125 6.34375 3.57506 6.34375 3.9375V7C6.34375 7.20656 6.441 7.40106 6.60625 7.525L8.35625 8.8375C8.6462 9.05496 9.05754 8.9962 9.275 8.70625C9.49246 8.4163 9.4337 8.00496 9.14375 7.7875L7.65625 6.67187V3.9375Z"
        fill={color}
      />
    </g>
    <defs>
      <linearGradient
        id="goalClockGradient"
        x1="7"
        y1="0.875"
        x2="7"
        y2="13.125"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCBD00" />
        <stop offset="1" stopColor="#F8CC4B" />
      </linearGradient>
      <clipPath id="goalClockClip">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const GoalShareIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M18.5417 9.32686L11.0417 2.6602C10.9518 2.57929 10.8403 2.52625 10.7208 2.50753C10.6013 2.4888 10.4789 2.5052 10.3686 2.55472C10.2582 2.60424 10.1647 2.68476 10.0992 2.78648C10.0338 2.8882 9.99931 3.00675 10 3.1277V5.83603H9.79166C7.41658 5.83868 5.13953 6.78335 3.46009 8.46279C1.78065 10.1422 0.835975 12.4193 0.833328 14.7944V17.2944C0.83322 17.4351 0.880766 17.5718 0.968225 17.6821C1.05568 17.7924 1.17791 17.8699 1.315 17.9019C1.3619 17.9134 1.41002 17.9193 1.45833 17.9194C1.57446 17.9194 1.68829 17.887 1.78706 17.8259C1.88583 17.7648 1.96562 17.6774 2.0175 17.5735L2.21416 17.1794C2.85069 15.896 3.83404 14.8167 5.05272 14.0638C6.2714 13.3108 7.67665 12.9144 9.10916 12.9194H10V16.461C9.9996 16.5817 10.0342 16.6998 10.0995 16.8012C10.1649 16.9026 10.2582 16.9829 10.3683 17.0324C10.4783 17.0818 10.6003 17.0983 10.7195 17.0799C10.8387 17.0615 10.95 17.0089 11.04 16.9285L18.54 10.2619C18.6061 10.2032 18.659 10.1312 18.6952 10.0507C18.7315 9.97007 18.7502 9.88272 18.7502 9.79436C18.7502 9.70601 18.7315 9.61866 18.6952 9.53807C18.659 9.45749 18.6061 9.3855 18.54 9.32686H18.5417Z"
      fill="currentColor"
    />
  </svg>
);

export const GoalArrowCircleIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect width="24" height="24" rx="12" fill="#FCBD00" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.9375 12C6.9375 11.6893 7.18934 11.4375 7.5 11.4375L15.142 11.4375L13.1022 9.39775C12.8826 9.17808 12.8826 8.82192 13.1022 8.60225C13.3219 8.38258 13.6781 8.38258 13.8977 8.60225L16.8977 11.6023C17.1174 11.8219 17.1174 12.1781 16.8977 12.3977L13.8977 15.3977C13.6781 15.6174 13.3219 15.6174 13.1023 15.3977C12.8826 15.1781 12.8826 14.8219 13.1023 14.6023L15.142 12.5625L7.5 12.5625C7.18934 12.5625 6.9375 12.3107 6.9375 12Z"
      fill="black"
    />
  </svg>
);

export const GoalSearchIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5 7C11.5 9.48528 9.48528 11.5 7 11.5C4.51472 11.5 2.5 9.48528 2.5 7C2.5 4.51472 4.51472 2.5 7 2.5C9.48528 2.5 11.5 4.51472 11.5 7ZM10.6792 11.7399C9.66322 12.5297 8.38653 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7C13 8.38653 12.5297 9.66322 11.7399 10.6792L14.5303 13.4697C14.8232 13.7626 14.8232 14.2374 14.5303 14.5303C14.2374 14.8232 13.7626 14.8232 13.4697 14.5303L10.6792 11.7399Z"
      fill="white"
      fillOpacity="0.45"
    />
  </svg>
);
